(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CleanWebUIPropertyGrid", [], factory);
	else if(typeof exports === 'object')
		exports["CleanWebUIPropertyGrid"] = factory();
	else
		root["CleanWebUIPropertyGrid"] = factory();
})(this, function() {
return 